export const getStyle = (el, styleProp) => {
	var camelize = function (str) {
		return str.replace(/-(\w)/g, function (str, letter) {
			return letter.toUpperCase();
		});
	};

	if (el.currentStyle) {
		return el.currentStyle[camelize(styleProp)];
	} else if (document.defaultView && document.defaultView.getComputedStyle) {
		return document.defaultView.getComputedStyle(el, null)
			.getPropertyValue(styleProp);
	} else {
		return el.style[camelize(styleProp)];
	}
}

export const convertToDDMMYYYY = (date, delimeter = '/') => {
	const mm = date.getMonth() + 1; // getMonth() is zero-based
	const dd = date.getDate();

	return [
		date.getFullYear(),
		(mm > 9 ? '' : '0') + mm,
		(dd > 9 ? '' : '0') + dd,
	].join(delimeter);
};

export const confirmRedirectOnClick = e => {
	e.preventDefault()
	const link = e.target.closest('a').href;
	if (link && window.confirm('You will be redirected to an external link. Are you sure to proceed ?')) {
		window.location.href = link
	}
}

export const getEllipsisText = (text, length) => text.toString().split('').slice(0, length - 3).join('') + '...'